module.exports = __webpack_public_path__ + "static/media/zebra01.ca9d54f4.png";